import React from 'react'
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ArrowR from '../../components/landingPage/icons/ArrowR'
import ArrowL from '../../components/landingPage/icons/ArrowL';


function SectionCarousel({ children, slideCounter, activeSlide, setActiveSlide }) {

  const nextSlide = () => {
    setActiveSlide(activeSlide + 1)
  }

  const prevSlide = () => {
    setActiveSlide(activeSlide - 1)
  }

  const onChange = (index) => {
    if (index !== activeSlide) {
      setActiveSlide(index);
    }
  }

  const MAIN_STYLE = {
    width:'480px',
    maxWidth:"100%"
  }
  return (
    <div style={MAIN_STYLE}>
      <Carousel infiniteLoop selectedItem={activeSlide} onChange={onChange} showArrows= {false} showThumbs={false} showIndicators={false} showStatus={false}>
        {children}
      </Carousel>
      <div className='flex'>
        <button className="mx-1 h-10 w-10 rounded-full bg-gray-300 text-blue-600 hover:bg-gray-700 hover:text-white" onClick={prevSlide}><ArrowL/></button>
        <button className="mx-1 h-10 w-10 rounded-full bg-gray-300 text-blue-600 hover:bg-gray-700 hover:text-white" onClick={nextSlide}><ArrowR/></button>
      </div>
    </div>
  )
}

export default SectionCarousel